module.exports = __webpack_public_path__ + "media/images/logo-ford-naked-72d37b6dfabd0f938a30b0c62eac1a50.svg";